export const POLICIES_URL = 'https://www.rimac.com/politica-privacidad';
export const ADDITIONAL_USE_CONSENT_URL = 'https://www.rimac.com/autorizacion-fines-adicionales';
